import { render } from "./TableBody.vue?vue&type=template&id=e8ae99ba&scoped=true&ts=true"
import script from "./TableBody.vue?vue&type=script&lang=ts"
export * from "./TableBody.vue?vue&type=script&lang=ts"

import "./table-body.scss?vue&type=style&index=0&id=e8ae99ba&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ae99ba"]])

export default __exports__